import Typography from '@mui/material/Typography';
import { pricingTypes } from '../liquidityTypes';
import {
  GradientBox,
  SpaceBetweenBox,
} from '../../../components/Containers/Box';

type Props = {
  value: pricingTypes;
};

export const PreviewPricingSetupSection = (props: Props) => {
  return (
    <GradientBox>
      <SpaceBetweenBox>
        <Typography variant="h2">Issuing Model Setup</Typography>
        <Typography variant="h4" fontWeight={600}>
          {props.value}
        </Typography>
      </SpaceBetweenBox>
    </GradientBox>
  );
};
